import { Cloud, Boxes, Layers } from 'lucide-react';

/** Three eras of enterprise inference on one spine: rented, assembled, one system. */

const eras = [
  { tag: 'Yesterday', title: 'Rented per token', detail: 'A frontier-model API. Data leaves the building; the bill grows with success.', icon: Cloud, state: 'past' as const },
  { tag: 'Today', title: 'Assembled open source', detail: 'A framework bolted onto vLLM across HTTP. Free, genuinely good — and a permanent team to own it.', icon: Boxes, state: 'present' as const },
  { tag: 'Fnk', title: 'One system, one contract', detail: 'Framework, control layer and engine built together. Capacity flows up, cancellation flows down.', icon: Layers, state: 'future' as const },
];

const node = {
  past: 'border-line bg-paper-2 text-ink-4',
  present: 'border-ink-3 bg-surface-2 text-ink',
  future: 'border-accent bg-accent text-paper',
};

export function Progression() {
  return (
    <div className="relative">
      <div className="absolute left-[16.666%] right-[16.666%] top-7 hidden h-px bg-line-strong sm:block" aria-hidden="true" />
      <div className="absolute bottom-7 left-7 top-7 w-px bg-line-strong sm:hidden" aria-hidden="true" />
      <ol className="relative m-0 grid list-none grid-cols-1 gap-8 p-0 sm:grid-cols-3 sm:gap-6">
        {eras.map((era) => {
          const Icon = era.icon;
          return (
            <li key={era.tag} className="flex items-start gap-4 sm:flex-col sm:items-center sm:gap-0 sm:text-center">
              <div className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-2 sm:mb-4 ${node[era.state]}`}>
                <Icon className="h-6 w-6" />
              </div>
              <div className="min-w-0">
                <p className="label mb-1">{era.tag}</p>
                <h3 className="mb-1.5 text-base font-semibold tracking-tight">{era.title}</h3>
                <p className="text-sm leading-relaxed text-ink-3 sm:mx-auto sm:max-w-[16rem]">{era.detail}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
